// 

import { ImageContent, LANDING_TYPE_CONTENT, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import ItemEditor from "./ItemEditor" 
import { ID } from "src/libs/interfaces/layouts"

/* Protopia Ecosystem component */
export interface IItemEditFormProps {
   i:number
   itemType?: LANDING_TYPE_CONTENT | string
   primitive: ImageContent | any
   children: JSX.Element
   items: any[]
   onAdd?: (sectionId: ID, i: number) => void
   onEdit?: () => void
}
const ItemEditForm = ( props: IItemEditFormProps ): JSX.Element => {
    const isEdit: boolean = useLandingStore((state: ILandingStore) => state.isEdit )
    const onAdd = ( sectionId: ID ) => {
        if(props.onAdd) {
            props.onAdd( sectionId, props.i )
        }
    }
    const onEdit = ( sectionId: ID ) => {
        if( props.onEdit ) {
            props.onEdit()
        }
        switch(props.itemType) {
            case undefined:
            case LANDING_TYPE_CONTENT.CARDS:                
                console.log( sectionId )
                break
            case LANDING_TYPE_CONTENT.BUTTONS: 
                console.log( sectionId )
                break
            case LANDING_TYPE_CONTENT.LINKS_FEED:
            case LANDING_TYPE_CONTENT.PASSAGE: 
            default:
                useLandingStore.setState({
                    curEditModal: {
                        currentEditType: SELECT_TYPE.LINK_ITEM,
                        sectionId,
                        order: props.i,
                        primitive: props.primitive
                    }
                })
                
        }
    }
    

    return isEdit
      ?
      <>
         { props.children }
         <ItemEditor 
            i={ props.i } 
            item={ props.items[ props.i ] } 
            type={ props.itemType || LANDING_TYPE_CONTENT.CARDS } 
            items={ props.items } 
            onEdit={ onEdit }
            onAdd={ onAdd }
         />
      </>
      :
      <>{props.children}</>
}
export default ItemEditForm